import ActualNumberOfSkips from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ActualNumberOfSkips";
import ActualQuantityField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ActualQuantityField";
import ATCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATCField";
import ATSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATSField";
import ETCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETCField";
import ETSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETSField";
import ExternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ExternalNotesAndAttachments";
import InternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/InternalNotesAndAttachments";
import MarpolAnnexGrid from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/MarpolAnnexGrid";
import RejectionReasonAndAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/RejectionReasonAndAttachment";
import ServiceReportAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ServiceReportAttachment";
import SlopsDisposalDocuments from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/SlopsDisposalDocuments";
import type { ChangeStatusDrawerInfo } from "@features/vessel-call/vessel-call-status/PortServices/hoc/withDrawers";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}

const MARPOL_OPTIONS_WASTE_SLOPS = [
  { value: "Oily bilge water", label: "Oily bilge water" },
  { value: "Oily tank washings", label: "Oily tank washings" },
  { value: "Dirty ballast water", label: "Dirty ballast water" },
  { value: "Other (Specify)", label: "Other (Specify)" },
];

const extraFieldsMap = {
  internalNotes: () => <InternalNotesAndAttachmentsComponent />,
  externalNotes: () => <ExternalNotesAndAttachmentsComponent />,
  rejectionReason: () => <RejectionReasonAndAttachment />,
  ats: (props: ExtraFieldProps) => <ATSField {...props} />,
  etc: (props: ExtraFieldProps) => <ETCField {...props} />,
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  ets: (props: ExtraFieldProps) => <ETSField {...props} />,
  actualQuantity: (props: ExtraFieldProps) => <ActualQuantityField {...props} />,
  actualNumberOfSkips: (props: ExtraFieldProps) => <ActualNumberOfSkips {...props} />,
  slopsDisposalDocuments: () => <SlopsDisposalDocuments />,
  serviceReportAttachment: () => <ServiceReportAttachment />,
  wasteResiduesForDischargeFacility: (props: ExtraFieldProps) => (
    <MarpolAnnexGrid {...props} marpolOptions={MARPOL_OPTIONS_WASTE_SLOPS} />
  ),
};

type SlopsExtraFieldsProps = {
  currentFlowStep: any;
  selectedStatus: string;
} & ExtraFieldProps;

const SlopsExtraFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: SlopsExtraFieldsProps) => {
  return (
    <div className="flex flex-col gap-2">
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];

              if (!FieldComponent) return null;

              return (
                <div className="mt-4" key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default SlopsExtraFields;
